var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":""}},[_c('at-qr-reader',{attrs:{"cancelTo":_vm.cancelTo},on:{"card-pending":_vm.onCardPending}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }